#import "../../../power-ai/timeline-summary/graphql/fragments/entity-summary-fragment.graphql"

query GetCallActivity($activityId: ID!) {
    activity(id: $activityId) {
        id
        logNote {
            id
            bodyHtml
        }
        transcription
        transcriptionStatus
        summary {
            ...EntitySummaryFragment
        }
    }
}
